export default __webpack_public_path__ + "static/media/roburna.8ff14247.webp";